import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getPowerBIConfig = createApi(`GetPowerBIReportsSlice`,"GET");

const GetPowerBIReportsSlice = createSlice({
  name: 'GetPowerBIReportsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPowerBIConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPowerBIConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPowerBIConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetPowerBIReportsSlice.reducer;